<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import { generalEmailAddress, instagram } from '@/constants';

const { locale } = useI18n();

const conditionsFile = computed(() => `/assets/documents/conditions-${locale.value}.pdf`);
const dataFile = computed(() => `/assets/documents/data-${locale.value}.pdf`);
</script>

<template>
  <footer
    class="flex flex-col justify-between w-full px-4 py-6 mt-auto bg-white lg:items-center lg:p-12 text-md lg:flex-row"
  >
    <ul class="flex flex-col gap-8 lg:flex-row">
      <li class="md:w-[10rem] lg:w-auto">
        {{ $t('navigation.footer.copyright.text') }} &copy;{{ $t('navigation.footer.copyright.brand') }}
      </li>
      <li>
        <a
          :href="`mailto:${generalEmailAddress}`"
          :aria-label="$t('home.contact.title')"
          class="underline hover:no-underline"
        >
          {{ $t('home.contact.title') }}
        </a>
      </li>
      <li>
        <a
          :href="conditionsFile"
          target="_blank"
          :aria-label="$t('navigation.footer.links.conditions.ariaLabel')"
          class="underline hover:no-underline"
        >
          {{ $t('navigation.footer.links.conditions.text') }}
        </a>
      </li>
      <li>
        <a
          :href="dataFile"
          target="_blank"
          :aria-label="$t('navigation.footer.links.data.ariaLabel')"
          class="underline hover:no-underline"
        >
          {{ $t('navigation.footer.links.data.text') }}
        </a>
      </li>
    </ul>
    <div class="flex flex-col items-start gap-6 mt-8 md:flex-row lg:mt-0">
      <div class="flex justify-between gap-6">
        <a
          :href="instagram"
          rel="noreferrer"
          target="_blank"
          :aria-label="$t('navigation.footer.socialMediaLabel.instagram')"
        >
          <Icon icon-name="instagram" class="h-7 w-7" />
        </a>
      </div>
      <div class="opacity-30">
        <p class="text-sm">{{ $t('navigation.footer.copyright.photos') }}</p>
        <p class="text-sm">{{ $t('navigation.footer.copyright.video') }}</p>
      </div>
    </div>
  </footer>
</template>
